
import React, { useEffect, useState } from "react";
import testimonialsData from "../../assets/testimonials.json";
import Testimonial from "../../models/common/Testimonials";

// import ClientPic1 from '../../assets/img/testmonials/testimonials-1.png';
// import ClientPic2 from '../../assets/img/testmonials/testimonials-2.png';
// import ClientPic3 from '../../assets/img/testmonials/testimonials-3.png';
// import ClientPic4 from '../../assets/img/testmonials/testimonials-4.png';
// import ClientPic5 from '../../assets/img/testmonials/testimonials-5.png';
// import ClientPic6 from '../../assets/img/testmonials/testimonials-6.png';
// import ClientPic7 from '../../assets/img/testmonials/testimonials-7.png';
// import ClientPic8 from '../../assets/img/testmonials/testimonials-8.png';
// import ClientPic9 from '../../assets/img/testmonials/testimonials-9.png';
// import ClientPic10 from '../../assets/img/testmonials/testimonials-10.png';
// import ClientPic11 from '../../assets/img/testmonials/testimonials-11.png';
// import ClientPic12 from '../../assets/img/testmonials/testimonials-12.png';
// import ClientPic13 from '../../assets/img/testmonials/testimonials-13.png';

import AvatarClient1 from '../../assets/img/avatar/avatar-client-1.png';
import AvatarClient2 from '../../assets/img/avatar/avatar-client-2.png';
import AvatarClient3 from '../../assets/img/avatar/avatar-client-3.png';
import AvatarClient4 from '../../assets/img/avatar/avatar-client-4.png';
import AvatarClient5 from '../../assets/img/avatar/avatar-client-5.png';
import AvatarClient6 from '../../assets/img/avatar/avatar-client-6.png';
import AvatarClient7 from '../../assets/img/avatar/avatar-client-7.png';
import AvatarClient8 from '../../assets/img/avatar/avatar-client-8.png';
import AvatarClient9 from '../../assets/img/avatar/avatar-client-9.png';
import AvatarClient10 from '../../assets/img/avatar/avatar-client-10.png';
import AvatarClient11 from '../../assets/img/avatar/avatar-client-11.png';
import AvatarClient12 from '../../assets/img/avatar/avatar-client-12.png';
import AvatarClient13 from '../../assets/img/avatar/avatar-client-13.png';
import AvatarClient14 from '../../assets/img/avatar/avatar-client-14.png';
import AvatarClient15 from '../../assets/img/avatar/avatar-client-15.png';
import AvatarClient16 from '../../assets/img/avatar/avatar-client-16.png';


type AvatarKey = "AvatarClient1" | "AvatarClient2" | "AvatarClient3" | "AvatarClient4" | "AvatarClient5" | "AvatarClient6" | "AvatarClient7" | "AvatarClient8" | "AvatarClient9" | "AvatarClient10" | "AvatarClient11" | "AvatarClient12" | "AvatarClient13" | "AvatarClient14" | "AvatarClient15" | "AvatarClient16";

const imageMap: Record<AvatarKey, string> = {
  AvatarClient1,
  AvatarClient2,
  AvatarClient3,
  AvatarClient4,
  AvatarClient5,
  AvatarClient6,
  AvatarClient7,
  AvatarClient8,
  AvatarClient9,
  AvatarClient10,
  AvatarClient11,
  AvatarClient12,
  AvatarClient13,
  AvatarClient14,
  AvatarClient15,
  AvatarClient16,

};

const TestimonialsComponent: React.FC = () => {

  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);

  useEffect(() => {
    // setTestimonials(testimonialsData as Testimonial[]);
    const shuffled = [...(testimonialsData as Testimonial[])].sort(() => Math.random() - 0.5);
    setTestimonials(shuffled);
  }, []);

  return (
    <div className="aboutUsBlock">
      <div className="aboutus-hero-banner">
        <div className="container">
          <h1>Testimonials</h1>
        </div>
      </div>

      <div className="container wrap-testimonial">
        {testimonials.map((item, index) => (
          <div className="panel" key={index}>
            <div>
              <div className="viewpoint">{item.viewpoint}</div>
              <h2 className="section-title">{item.title}</h2>
              <p className="desc">{item.desc}</p>
              <div className="meta">
                <div className="avatar" aria-hidden="true">
                  <img src={imageMap[item.avatar]} alt={item.who} />
                </div>
                <div>
                  <div className="who">{item.who}</div>
                  {item.company && (
                    <div className="company">{item.company}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="visual">
              <div className="sidebar"></div>
              <div className="card">
                <svg width="320" height="220" viewBox="0 0 320 220">
                  <rect width="320" height="220" rx="12" fill="#fff" />
                  <g opacity="0.12">
                    <circle cx="80" cy="60" r="70" fill="#3E7FDC" />
                    <rect
                      x="170"
                      y="30"
                      width="160"
                      height="140"
                      rx="16"
                      fill="#F1BA35"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TestimonialsComponent;